(function () {
  const revealSelectors = [
    '.bizafrika-catalogue__portfolio-heading',
    '.bizafrika-catalogue__category-grid article',
    '.bizafrika-catalogue__brand-heading',
    '.bizafrika-brand-card',
    '.bizafrika-catalogue__access-plan',
    '.bizafrika-access-foundation__state-card',
    '.bizafrika-access-foundation__workspace-link',
    '.bizafrika-b2b-application__login-card',
    '.bizafrika-b2b-application__form-card',
    '.bizafrika-b2b-application__process',
    '.bizafrika-contact__form-card',
    '.bizafrika-contact__details'
  ];

  function initialiseReveals() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = document.querySelectorAll('[data-bizafrika-reveal], ' + revealSelectors.join(', '));

    if (!items.length) return;

    items.forEach(function (item, index) {
      item.setAttribute('data-bizafrika-reveal', '');
      item.style.setProperty('--bizafrika-reveal-order', String(index % 6));
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    document.documentElement.classList.add('bizafrika-motion-ready');

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    items.forEach(function (item) { observer.observe(item); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseReveals, { once: true });
  } else {
    initialiseReveals();
  }
})();

(function () {
  const banner = document.querySelector('[data-bizafrika-consent]');
  const acceptButton = banner?.querySelector('[data-bizafrika-consent-accept]');
  const rejectButton = banner?.querySelector('[data-bizafrika-consent-reject]');
  const manageButtons = document.querySelectorAll('[data-bizafrika-consent-manage]');
  let metaLoaded = false;
  let untappedLoaded = false;

  if (!banner) return;

  function setBannerHidden(hidden) {
    banner.hidden = hidden;
    manageButtons.forEach(function (button) { button.hidden = !hidden; });
  }

  function privacyApi() {
    return window.Shopify?.customerPrivacy || null;
  }

  function publishPrivacyState(status, analyticsAllowed, marketingAllowed) {
    const root = document.documentElement;
    if (root) {
      root.dataset.bizafrikaPrivacyState = status;
      root.dataset.bizafrikaAnalyticsConsent = analyticsAllowed ? 'yes' : 'no';
      root.dataset.bizafrikaMarketingConsent = marketingAllowed ? 'yes' : 'no';
    }
    document.dispatchEvent(new window.CustomEvent('bizafrika:privacy-state', {
      detail: {
        status: status,
        analytics: Boolean(analyticsAllowed),
        marketing: Boolean(marketingAllowed)
      }
    }));
  }

  let privacyPromise;
  function ensurePrivacyApi() {
    if (privacyApi()) return Promise.resolve(privacyApi());
    if (privacyPromise) return privacyPromise;
    privacyPromise = new Promise(function (resolve, reject) {
      let attempts = 0;
      function load() {
        if (privacyApi()) return resolve(privacyApi());
        if (typeof window.Shopify?.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
            if (error || !privacyApi()) reject(new Error('Privacy API unavailable'));
            else resolve(privacyApi());
          });
        } else if (++attempts < 40) {
          window.setTimeout(load, 250);
        } else {
          reject(new Error('Privacy API loader unavailable'));
        }
      }
      load();
    }).catch(function (error) {
      privacyPromise = null;
      throw error;
    });
    return privacyPromise;
  }

  function loadMetaPixel() {
    if (metaLoaded || window.fbq) return;
    metaLoaded = true;
    const fbq = window.fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', '1398866032350863');
    fbq('track', 'PageView');
  }

  function loadUntappedTracking() {
    if (untappedLoaded) return;
    untappedLoaded = true;
    const script = document.createElement('script');
    script.src = 'https://api.untappedai.co.za/js/external-tracking.js';
    script.dataset.trackingId = 'tk_a24e9fda4aa74fed9d54f4ce7549e224';
    script.defer = true;
    document.body.appendChild(script);
  }

  function syncPrivacy() {
    const api = privacyApi();
    if (!api) {
      setBannerHidden(false);
      publishPrivacyState('unavailable', false, false);
      return;
    }

    const consent = api.currentVisitorConsent();
    const analyticsAllowed = consent.analytics === 'yes' && api.analyticsProcessingAllowed();
    const marketingAllowed = consent.marketing === 'yes' && api.marketingAllowed();
    if (marketingAllowed) loadMetaPixel();
    if (analyticsAllowed && marketingAllowed) loadUntappedTracking();
    publishPrivacyState('ready', analyticsAllowed, marketingAllowed);

    const needsChoice = !['yes', 'no'].includes(consent.analytics) || !['yes', 'no'].includes(consent.marketing);
    setBannerHidden(!needsChoice);
    banner.dataset.privacyState = 'ready';
  }

  async function setConsent(accepted) {
    const buttons = [acceptButton, rejectButton].filter(Boolean);
    buttons.forEach(function (button) { button.disabled = true; });
    banner.setAttribute('aria-busy', 'true');
    try {
      const api = await ensurePrivacyApi();
      await new Promise(function (resolve, reject) {
        api.setTrackingConsent({
          analytics: accepted,
          marketing: accepted,
          preferences: accepted
        }, function (error) {
          if (error) reject(error);
          else resolve();
        });
      });
      syncPrivacy();
      if (!accepted && (metaLoaded || untappedLoaded)) window.location.reload();
    } catch (error) {
      setBannerHidden(false);
      banner.dataset.privacyState = 'unavailable';
      publishPrivacyState('unavailable', false, false);
      console.warn('Privacy choice was not saved; non-essential tracking remains gated.', error);
    } finally {
      buttons.forEach(function (button) { button.disabled = false; });
      banner.removeAttribute('aria-busy');
    }
  }

  acceptButton?.addEventListener('click', function () { setConsent(true); });
  rejectButton?.addEventListener('click', function () { setConsent(false); });
  manageButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setBannerHidden(false);
      acceptButton?.focus();
    });
  });
  document.addEventListener('visitorConsentCollected', syncPrivacy);

  banner.dataset.privacyState = 'loading';
  publishPrivacyState('loading', false, false);
  ensurePrivacyApi().then(syncPrivacy).catch(function (error) {
    setBannerHidden(false);
    banner.dataset.privacyState = 'unavailable';
    publishPrivacyState('unavailable', false, false);
    console.warn('Privacy controls could not load; non-essential tracking remains gated.', error);
  });
})();
